module.exports = __webpack_public_path__ + "images/expertMoneyGradient-3599291d9df1741690059d87f8200dcc.svg";